// src/pages/ResetPassword/ResetPassword.js
import React, { useState } from 'react'
import {
  Container, Paper, TextField, Button,
  Typography, Box, Alert, InputAdornment, IconButton
} from '@mui/material'
import { LockResetRounded, VisibilityRounded, VisibilityOffRounded } from '@mui/icons-material'
import { useParams, useNavigate, Link as RouterLink } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import api from '../../services/api'
import { mensagemDeErro } from '../../services/erros'

const ResetPassword = () => {
  const { uid, token } = useParams()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)

  const { register, handleSubmit, watch, formState: { errors } } = useForm()
  const newPassword = watch('new_password', '')

  const onSubmit = async (data) => {
    setLoading(true)
    setError('')
    try {
      await api.post('/api/auth/password-reset/confirm/', {
        uid, token, new_password: data.new_password
      })
      setSuccess(true)
      setTimeout(() => navigate('/login'), 3000)
    } catch (err) {
      setError(mensagemDeErro(err, 'Link inválido ou expirado. Solicite um novo.'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <Container component='main' maxWidth='xs'>
      <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Paper elevation={3} sx={{ p: 3, width: '100%', borderRadius: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
            <Box component='img' src='/logo_aux.png' alt='Umarkt' sx={{ width: 50, height: 50 }} />
            <Typography component='h1' variant='h5' fontWeight='bold'>Umarkt</Typography>
          </Box>
          <Typography variant='h6' textAlign='center' fontWeight={600} sx={{ mb: 1 }}>
            Nova senha
          </Typography>

          {success ? (
            <>
              <Alert severity='success' sx={{ mb: 2 }}>
                <Typography variant='body2' fontWeight={600} gutterBottom>Senha redefinida!</Typography>
                <Typography variant='body2'>Redirecionando para o login em instantes...</Typography>
              </Alert>
              <Button fullWidth variant='contained' component={RouterLink} to='/login'>
                Ir para o login
              </Button>
            </>
          ) : (
            <>
              {error && <Alert severity='error' sx={{ mb: 2 }}>{error}</Alert>}
              <Box component='form' onSubmit={handleSubmit(onSubmit)}>
                <TextField
                  margin='dense' required fullWidth size='small'
                  label='Nova senha'
                  type={showPassword ? 'text' : 'password'}
                  error={!!errors.new_password}
                  helperText={errors.new_password?.message || 'Mínimo 6 caracteres'}
                  {...register('new_password', {
                    required: 'Senha é obrigatória',
                    minLength: { value: 6, message: 'Mínimo 6 caracteres' }
                  })}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>
                        <IconButton size='small' onClick={() => setShowPassword(!showPassword)} edge='end'>
                          {showPassword ? <VisibilityOffRounded /> : <VisibilityRounded />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
                <TextField
                  margin='dense' required fullWidth size='small'
                  label='Confirmar nova senha'
                  type={showConfirm ? 'text' : 'password'}
                  error={!!errors.confirm_password}
                  helperText={errors.confirm_password?.message}
                  {...register('confirm_password', {
                    required: 'Confirmação é obrigatória',
                    validate: v => v === newPassword || 'As senhas não coincidem'
                  })}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>
                        <IconButton size='small' onClick={() => setShowConfirm(!showConfirm)} edge='end'>
                          {showConfirm ? <VisibilityOffRounded /> : <VisibilityRounded />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
                <Button
                  type='submit' fullWidth variant='contained'
                  sx={{ mt: 2, mb: 2, py: 1 }} disabled={loading}
                  startIcon={<LockResetRounded />}
                >
                  {loading ? 'Salvando...' : 'Salvar nova senha'}
                </Button>
              </Box>
            </>
          )}
        </Paper>
      </Box>
    </Container>
  )
}

export default ResetPassword
